<template>
    <div class="progress-container">
        <div class="progress-bar">
            <div :style="{ 'height': strokeStyle }" class="progress-bar_outer">
                <div :style="{ 'width': percentageStyle }" class="progress-bar_inner" />
            </div>
        </div>
        <div :style="{'font-size': strokeStyle}" class="progress-status">{{ percentageStyle }}</div>
    </div>
</template>

<script>
export default {
    name: 'progress-bar',
    props: {
        'stroke_width': {
            type: Number,
            default: 20
        },
        'percentage': {
            type: Number,
            default: 0
        }
    },
    computed: {
        strokeStyle() {
            return this.stroke_width.toString() + 'px'
        },
        percentageStyle() {
            return this.percentage.toString() + '%'
        }
    }
}
</script>

<style lang="stylus" scoped>
    .progress-container
        width: 100%
    .progress-bar
        display: inline-block
        padding-right: 50px
        width: 100%
        margin-right: -55px
        -webkit-box-sizing: border-box
        box-sizing: border-box
        vertical-align: middle
    .progress-bar_outer
        border-radius: 100px
        background-color: #EBEEF5
        overflow: hidden
        position: relative
        vertical-align: middle
    .progress-bar_inner
        position: absolute
        left: 0
        top: 0
        height: 100%
        background-color: #409EFF
        text-align: right
        border-radius: 100px
        line-height: 1
        white-space: nowrap
        -webkit-transition: width .6s ease
        -o-transition: width .6s ease
        transition: width .6s ease
    .progress-status
        color: #606266
        display: inline-block
        vertical-align: middle
        margin-left: 10px
        line-height: 1
</style>